// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__1fRts","tab":"UserNav_tab__3V_Zc"};